import { rankWith, isEnumControl } from '@jsonforms/core'
import { SCHEMA_SHAPE_RANK } from './ranks'

// Tells Jsonforms which control/component should be used.
export default rankWith(SCHEMA_SHAPE_RANK, isEnumControl)
